import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { RelationshipsIcon } from '../global/CustomIcons';

import PageBreadcrumbs from '../common/PageBreadcrumbs';
import SignalRelationshipsGraph from './SignalRelationshipsGraph';

/* Sidebar · Intelligence · Relationships — the workspace-wide statistical
   map: correlations + Granger causality over every signal, rendered as one
   interactive constellation. Goal-conditioned, validated relationships
   live in Discovery; this is the raw statistical terrain beneath them. */

const RelationshipsPage = () => (
  <Box sx={{ width: '100%', position: 'relative', mb: 4 }}>
    <Stack sx={{ mb: 1.5 }}>
      <PageBreadcrumbs
        items={[{ text: 'Relationships', icon: <RelationshipsIcon /> }]}
        mb={0.5}
      />
      <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
        How your signals move together and which ones lead — correlations and
        causal directions in one graph. Click any node or edge for the details.
      </Typography>
    </Stack>

    <SignalRelationshipsGraph />
  </Box>
);

export default RelationshipsPage;
